import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, message, Upload } from "antd";
import { UploadOutlined, SmileOutlined } from "@ant-design/icons";
import { firestore, storage } from "../../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate, useLocation } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import { regexPattern } from "../../utils/constants";
import { Country, State, City } from "country-state-city";
import Select from "react-select";

const AddStory = ({}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [fileList, setFileList] = useState([]);
  const [image, setImage] = useState("null");
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");
  const [location, setLocation] = useState({ state: "", city: "" });

  const handleImageChange = async (e) => {
    if (e.target.files.length > 0) {
      let ext = e.target.files[0].name;
      ext = ext.split(".");

      if (ext[1] == "svg") {
        form.setFields([
          {
            name: "image", // required
            errors: ["SVG image is not allowed"],
          },
        ]);
      } else {
        form.setFields([
          {
            name: "image", // required
            errors: [],
          },
        ]);
      }
      setImage(e.target.files[0]);
    }
  };
  
  const add_story = async () => {
    setLoading(true);

    try {
      const newPost = {
        timeStamp: Date.now(),
      };

      if (!regexPattern.test(title)) {
        form.setFields([
          {
            name: "title", // required
            errors: ["Name must containe  characters only"],
          },
        ]);
      } else
        form.setFields([
          {
            name: "title", // required
            errors: [],
          },
        ]);
      if (title) {
        newPost.title = title;
        newPost.country = "India";
      }

      if (content) {
        newPost.content = content;
      }
      if (!newPost?.content || newPost?.content == "") {
        form.setFields([
          {
            name: "content", // required
            errors: ["Description  is required"],
          },
        ]);
      } else
        form.setFields([
          {
            name: "content", // required
            errors: [],
          },
        ]);
      if (!image || image == "" || image == "null") {
        form.setFields([
          {
            name: "image", // required
            errors: ["image  is required"],
          },
        ]);
      } else {
        let ext = image?.name;
        ext = ext.split(".");

        if (ext[1] == "svg") {
          form.setFields([
            {
              name: "image", // required
              errors: ["SVG image is not allowed"],
            },
          ]);
          setLoading(false);
          return;
        } else {
          form.setFields([
            {
              name: "image", // required
              errors: [],
            },
          ]);
        }
      }

      if (!location.state || location.state == "") {
        form.setFields([
          {
            name: "state", // required
            errors: ["Select State"],
          },
        ]);
      } else
        form.setFields([
          {
            name: "state", // required
            errors: [],
          },
        ]);
      if (!location.city || location.city == "") {
        form.setFields([
          {
            name: "city", // required
            errors: ["Select City"],
          },
        ]);
      } else
        form.setFields([
          {
            name: "city", // required
            errors: [],
          },
        ]);
      let er = 0;
      form
        .getFieldsError()
        .map((el) => el.errors)
        .forEach((el) => {
          if (el.length > 0) er++;
        });
      if (er > 0) {
        setLoading(false);
        return;
      }
      newPost.state = location.state;
      newPost.city = location.city;
      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `success_story/${uniqueFilename}`);
      const contentType = image.type.split("/");

      const metadata = {
        contentType: image.type,
      };
      await uploadBytes(storageRef, image, metadata);
      let imageUrl = await getDownloadURL(storageRef);
      contentType[0] == "video"
        ? (newPost.video = imageUrl)
        : (newPost.images = imageUrl);

      await addDoc(collection(firestore, "success_story"), newPost);

      form.resetFields();
      setTitle("");
      setContent("");
      setPreviewImage(null);
      setFileList([]);
      setLocation({ state: "", city: "" });
      message.success("Story added successfully!");
      setLoading(false);
      navigate("/success-story");
    } catch (error) {
      setLoading(false);
      message.error(
        "Failed to add post. Please check the form fields and try again."
      );
    }
  };

  
  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, []);
  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name };
        }),
      ]);
    }
  }, [stateCode]);
  return (
    <div
      style={{
        alignItems: "center",
        overflow: "auto",
        maxHeight: "100vh",
        paddingRight: "0px",
        width: "97.5%",
      }}
    >
      <h2>Add Story</h2>

      <Form
        form={form}
        onFinish={add_story}
        clabelcol={{ span: 6 }}
        wrappercol={{ span: 16 }}
        disabled={loading}
      >
        <Form.Item
          label="Name"
          name="title"
          rules={[
            { required: true, message: "Name is required" },
            { max: 80, message: "Name should be maximum 50 characters!" },
          ]}
        >
          <Input
            style={{
              width: "50%",
              height: 50,
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item
          label="Description"
          name="content"
          rules={[
            {
              max: 500,
              message: "Description should be maximum 500 characters!",
            },
          ]}
        >
          <Input.TextArea
            style={{
              width: "100%",
              height: 200,
              overflow: "hidden",
              whiteSpace: "wrap",
            }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="State" name="state">
          <Select
            onChange={async (a) => {
              setStateCode(a.value);
              setLocation({ ...location, state: a.label });
            }}
            options={stateList}
            placeholder="Select state"
          />
        </Form.Item>
        {cityList.length ? (
          <Form.Item label="City" name="city">
            <Select
              onChange={async (a) => {
                setLocation({ ...location, city: a.label });
              }}
              options={cityList}
              placeholder="Select city"
            />
          </Form.Item>
        ) : (
          <></>
        )}
        <Form.Item label="Image" name="image">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            disabled={loading}
            value={image}
          />
        </Form.Item>

        <Form.Item>
          {loading ? (
            <CircularProgress size={10} />
          ) : (
            <Button
              type="primary"
              htmlType="submit"
              disabled={!(title || content || image)}
            >
              Add University
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddStory;
